<template lang="pug">
div
  e-z-toolbar(
    :title="'Reports'",
    @counterSelected="onCounterSelect()",
    @sectionSelected="onSectionSelect()",
    @allSelected="onRestaurantSelect()"
  )
  v-container.pa-0(fluid)
    v-row(justify-left, no-gutters)
      v-col(
        v-for="group in reportGroups",
        :key="group.name",
        cols="12",
        xs="12",
        sm="6",
        md="4",
        lg="3",
        xl="2"
      )
        v-sheet(color="grey lighten-2")
          v-row(no-gutters)
            v-col
              .pl-3.pr-3
                div(style="float:left")
                  v-icon(small) mdi-plus-box-multiple
                  strong.pl-2 {{ group.name }}: ({{ group.reports.length }})
                div(v-if="group.isFilterable", style="float:right")
                  v-menu(offset-x)
                    template(v-slot:activator="{ on }")
                      div(v-on.stop="on")
                        strong Age
                        v-icon(small, color="red") mdi-filter-variant
                        strong &lt;{{ closedReportsAge }}{{  closedReportsAge==1?&apos;day&apos;:&apos;days&apos;  }}
                    v-list
                      v-list-item(
                        v-for="i in getFilterOptions()",
                        :key="i",
                        @click="closedReportsAge = i; loadClosedReports()"
                      ) {{ i }}{{  i==1?&apos;day&apos;:&apos;days&apos;  }}
          v-divider
          v-card
            v-card-text.pa-0(v-for="report in group.reports", :key="report.id")
              v-list-item
                v-list-item-content
                  v-list-item-title
                    strong {{ getReportTitle(report) }}
                  v-list-item-subtitle
                    | Code:
                    code {{ report.code }}
                    | In-Charge: {{ report.inCharge }}
                v-list-item-action
                  v-list-item-action-text
                    span(v-if="myFeatures.eligibleFeatures.includes('TIMER')") {{ getPeriod(report) }}
                    span(v-else) {{  moment(report.openTS).format(&apos;LT&apos;)  }}
                  v-list-item-action-text
                    v-icon.pl-3(@click="vibrate(); view(report)") mdi-table-of-contents
              v-divider
  report-dialog(
    v-if="mode.reportDialog",
    :editedItem="editedItem",
    :mode="mode",
    v-on:save="save($event)",
    v-on:delete="deleteItem($event)"
  )
</template>

<script>
import moment from "moment";
import EZToolbar from "../components/shared/EZToolbar.vue";
import ReportDialog from "../components/dialogs/Report.vue";
import { storeMixin } from "../mixins/storeMixin.js";
const pause = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export default {
  name: "items",
  mixins: [storeMixin],
  components: { EZToolbar, ReportDialog },
  async beforeMount() {
    //bind users otherwise report wont run
    if (!this.users.length) {
      this.bindUsers();
      await pause(1000);
    }
    const reportId = this.$route.params.reportId;
    if (reportId) {
      let report = this.reports.find((r) => r.id === reportId);
      if (!report) {
        setTimeout(() => {
          report = this.reports.find((r) => r.id === reportId);
          this.view(report);
        }, 1000);
      } else {
        this.view(report);
      }
    } else {
      await this.loadClosedReports();
    }
  },
  data() {
    return {
      moment: moment,
      routeParams: {},
      mode: {
        reportDialog: false,
      },
      isCounterOpen: false,
      isRestaurantOpen: false,
      search: "",
      editedItem: {},
      closedReports: [],
      closedReportsAge: 1,
    };
  },
  computed: {
    reportGroups() {
      return [
        {
          name: this.isRestaurantOpen
            ? "Restaurant Report - Open"
            : this.isCounterOpen
            ? "Counter Report - Open"
            : "Section Report - Open",
          reports: this.filteredReports.filter(
            (r) => r.status === this.STATUSES.OPEN
          ),
          isFilterable: false,
        },
        {
          name: this.isRestaurantOpen
            ? "Restaurant Report - Closed"
            : this.isCounterOpen
            ? "Counter Report - Closed"
            : "Section Report - Closed",
          reports: this.filteredReports.filter(
            (r) => r.status === this.STATUSES.ACTIVE
          ),
          isFilterable: true,
        },
      ];
    },
    filteredReports() {
      let filteredReports = [];
      const reports = [...this.reports, ...this.closedReports];
      if (this.isRestaurantOpen) {
        filteredReports = reports.filter((r) => {
          return (
            r._restaurantKey === this.selectedRestaurant.id &&
            r.reportType === "restaurant"
          );
        });
      } else if (this.isCounterOpen) {
        filteredReports = reports.filter((r) => {
          return (
            r._counterKey === this.selectedCounter.id &&
            r.reportType === "counter"
          );
        });
      } else {
        filteredReports = reports.filter((r) => {
          return (
            r._sectionKey === this.selectedSection.id &&
            r.reportType === "section"
          );
        });
      }
      return filteredReports;
    },
  },
  methods: {
    onCounterSelect() {
      this.isCounterOpen = true;
      this.isRestaurantOpen = false;
    },
    onSectionSelect() {
      this.isCounterOpen = false;
      this.isRestaurantOpen = false;
    },
    onRestaurantSelect() {
      this.isCounterOpen = false;
      this.isRestaurantOpen = true;
    },
    getFilterOptions() {
      return [1, 7, 30, 90, 180].filter(
        (i) => i <= this.myFeatures.eligibleCounts.B
      );
    },
    async loadClosedReports() {
      const day = 24 * 60 * 60 * 1000; //milliseconds
      const allowedAge = Date.now() - this.closedReportsAge * day;
      const predicates = [
        {
          key: "_restaurantKey",
          op: "==",
          val: this.selectedRestaurant.id,
        },
        {
          key: "status",
          op: "==",
          val: this.STATUSES.CLOSEDOUT,
        },
        {
          key: "openTS",
          op: ">",
          val: allowedAge,
        },
      ];
      this.closedReports = await this.loadDocs({
        collectionName: "reports",
        predicates: predicates,
      });
    },
    getReportTitle(report) {
      if (report.status === this.STATUSES.OPEN) {
        return moment(Number(report.openTS)).format(
          "DD-MMM-YYYY[(Opened at ]LT[)]"
        );
      } else {
        let title = moment(Number(report.openTS)).format("DD-MMM-YYYY[(]LT");
        title += `${moment(Number(report.closedTS || Date.now())).format(
          "[ till ]LT[)]"
        )}`;
        return title;
      }
    },
    getPeriod(report) {
      const minutes = parseInt(
        ((report.closedTS || Date.now()) - report.openTS) / 60000
      );
      const hours = parseInt(minutes / 60);
      const mins = minutes % 60;
      return hours + "hr" + mins + "m";
    },
    view(report) {
      this.editedItem = Object.assign({}, report);
      this.mode.reportDialog = true;
    },
  },
  watch: {
    selectedRestaurant() {
      this.bindReports();
    },
  },
};
</script>